import * as moment from 'moment';
import { CommunicationSettingType } from './communication-settings';

export abstract class CommunicationsSettingBase {
  enabled: boolean;
  communicationSettingType: CommunicationSettingType;
  workerCronSchedule: string;
  workerStartTime: moment.Duration;
  workerEndTime: moment.Duration;
  firstNotificationBefore: string;
  repeatNotificationEvery: string;

  constructor(data: Partial<CommunicationsSettingBase> = {}) {
    Object.assign(this, data)
  }
}
